import Button from '@components/v2/ui/Button/Button';
import { ProductDetailsTestIds } from '../../../../../../../utils/testIds/productDetails.testIds';
import OrderProductPacksMenu from '../../../../../../orders/products/product/grid/components/packsMenu/components/OrderProductPacksMenu';
import { useCombinationPackChipStyles } from './combinationPackChip.styles';
import useCombinationPackChip from './hooks/useCombinationPackChip';

const CombinationPackChip = () => {
  const { classes } = useCombinationPackChipStyles();
  const { label, isPacksMenuOpen, canOpenPacksMenu, openPacksMenu, closePacksMenu } =
    useCombinationPackChip();

  return (
    <>
      <Button
        variant="contained"
        shape="square"
        tabIndex={-1}
        aria-label={label}
        className={classes.chip}
        testId={ProductDetailsTestIds.COMBINATION_PACK_CHIP}
        onClick={canOpenPacksMenu ? openPacksMenu : undefined}
      >
        <span className={classes.label}>{label}</span>
      </Button>

      {isPacksMenuOpen && <OrderProductPacksMenu open handleClose={closePacksMenu} />}
    </>
  );
};

export default CombinationPackChip;
